export default __webpack_public_path__ + "static/media/bars-search-search-bar.3b1dfd3f.svg";